import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import useNavigateTo from 'hooks/useNavigateTo'
import TextLink from 'LuxKit/TextLink'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import Caption from 'LuxKit/Typography/Caption'

const MobileNavigationBox = styled.div`
  background: transparent;
  border-radius: ${rem(8)};
  padding: ${rem(12)} 0;
  min-width: ${rem(200)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${rem(16)};
  
  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`

interface Props {
  linkTourDetails: {
    tourId: string
    assignYear: number
    title: string
  }
}

function TourV2YearNavigationBoxesMobile(props: Props) {
  const { linkTourDetails } = props
  const navigateTo = useNavigateTo()
  const intl = useIntl()

  const handleLinkTourClick = useCallback(() => {
    navigateTo(`/tour/tour-${linkTourDetails.tourId}`)
  }, [navigateTo, linkTourDetails])

  return (
    <MobileNavigationBox>
      <Caption variant="medium" weight="bold">
        {linkTourDetails.title}
      </Caption>
      <TextLink
        size="caption"
        startIcon={<LineCalendarIcon />}
        weight="regular"
        onClick={handleLinkTourClick}
      >
        {intl.formatMessage(
          {
            id: 'XqfcPMptW9',
            defaultMessage: 'Explore {year} tour',
            description: 'Link text to navigate to a tour page for a specific year',
          },
          { year: linkTourDetails.assignYear },
        )}
      </TextLink>
    </MobileNavigationBox>
  )
}

export default React.memo(TourV2YearNavigationBoxesMobile)
